import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, useMatch } from 'react-router-dom';
import UiIcon from './ui/UiIcon';

// "Manage" trigger in the top bar: opens on hover, or on tap for touch screens.
function ManageMenu({ items, email, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const location = useLocation();
  const isActive = !!useMatch('/admin/manage/*');

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  return (
    <div
      ref={ref}
      className={`menu ${open ? 'open' : ''}`}
      onPointerEnter={(e) => e.pointerType === 'mouse' && setOpen(true)}
      onPointerLeave={(e) => e.pointerType === 'mouse' && setOpen(false)}
    >
      <button
        type="button"
        className={`tab-button tab-secondary menu-trigger ${isActive ? 'active' : ''}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        Manage <UiIcon name="expand_more" />
      </button>
      {open && (
        <div className="menu-panel" role="menu">
          {items.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              role="menuitem"
              className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
          <div className="menu-divider" />
          <div className="menu-note" title={email}>{email}</div>
          <button type="button" role="menuitem" className="menu-item menu-item-danger" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}

export default ManageMenu;
